
import {BOOK_PERMISSION, CONTENT_CLASSES} from "../../../utils/content/content.constants";

export const parseResponseSearchDictionaryContent = (response) => {
  return response.data.map((item) => ({
    id: item.para_id,
    ...item,
    isForSale: item.action_required === BOOK_PERMISSION.purchased,
    className: CONTENT_CLASSES.BOOK,
  }));
};
